import { getObjectKeysAsObject } from "../../../../helpers";
import { completeInteractiveFulfillService } from "./completeInteractiveFulfill";
import { loyaltySubmitService } from "./loyaltySubmit";
import { pollFulfillService } from "./pollFulfill";
import { pollInteractivePaymentAuthService } from "./pollInteractivePaymentAuth";
import { pollUserActionService } from "./pollUserAction";
import { scheduleFulfillService } from "./scheduleFulfill";

export const services = {
  completeInteractiveFulfillService,
  loyaltySubmitService,
  pollFulfillService,
  scheduleFulfillService,
  pollUserActionService,
  pollInteractivePaymentAuthService,
};

export const ServiceTypes = getObjectKeysAsObject(services);
